/** 停機啟用 */
export enum MaintenanceEnabled {
  Y = 'Y',
  N = 'N'
}
